import React, { useEffect, useState } from 'react'
import { BsChatDotsFill } from 'react-icons/bs'
import { FaHighlighter } from 'react-icons/fa'
import { toast } from "react-toastify";
import { MdViewQuilt, MdVideocam, MdAmpStories, MdArrowBackIos, MdArrowForwardIos, MdChevronRight, MdLayers, MdTheaters, MdMovie, MdOutlineArticle, MdOutlineSentimentSatisfied } from 'react-icons/md'
import ScenePanel from './ScenePanel/ScenePanel'
import BackButton from './BackButton'
import { setCharacters, setNotes, setScenes } from '../../../../store/scriptSlice'
import { getScenes } from '../utils/sceneutils'
import { useDispatch, useSelector } from 'react-redux'

import EmptyPage from './EmptyPage'
import { getCharacter } from '../utils/characterUtils'
import CharacterPanel from './CharacterPanel/CharacterPanel'
import { Button } from 'antd'
import InvitePanel from './InvitePanel'
import ElementsPanel from './CategoriesAndElementsPanel'
import { getElements } from '../utils/elementsUtils'
import SceneCardPanel from './SceneCardsPanel'
import { getSceneCards } from '../utils/sceneCardsUtils'
import RevisionTab from '../../Revisions/RevisionTab.js'
import { useNavigate, useParams } from 'react-router-dom'
import { getAccessToken } from '../../../../services/authService'
import NotesPanel from './NotesPanel';
import LoaderSpin from '../../../Common/LoaderSpin';
import SubscriptionModal from './SubscriptionModal';
import RevisionsPanel from './RevisionPanel';
import { getPlanFeatures } from '../../../../utils/access';
import useSubscriptionAccess from '../../../../utils/useSubscriptionAccess';
import SharedStoryboardViewer from './SharedStoryboardViewer';

const SidePanel = ({ editor, scriptData, scriptAccess, mobileProductionOpen = false, onCloseMobileProduction, mobileMenuOpen = false, onCloseMobileMenu, onOpenMedia, charactersRequest = 0 }) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const planFeatures = getPlanFeatures(user) || {}
    const subscription = user?.subscription || {}
    const [panel, setPanel] = useState('')
    useEffect(() => { if (charactersRequest) setPanel('character') }, [charactersRequest])
    const activePanel = mobileProductionOpen ? 'elements' : panel
    const [updateScenes, setUpdateScenes] = useState(false)
    const [updateCharacters, setUpdateCharacters] = useState(false)
    const [updateElements, setUpdateElements] = useState(false)
    const scenes = useSelector(state => state.script.scenes)
    const characters = useSelector(state => state.script.characters.allCharacters)
    const [revisions, setRevisions] = useState([])
    const notes = useSelector(state => state.script.notes)
    const [sceneElements, setSceneElements] = useState([])
    const [sceneCards, setSceneCards] = useState([])
    const { id } = useParams()

    const [users, setUsers] = useState([]);
    const subscriptionAccess=useSubscriptionAccess();
    const [documentWrite, setHavePermissionToEdit] = useState(false);
    const havePermissionToEdit=scriptAccess?.canEdit===true;
    const [isPopUpOpen, setIsPopUpOpen] = useState(false);
    const [updateCollaborators, setUpdateCollaborators] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);
    const [sharedStoryboardsOpen, setSharedStoryboardsOpen] = useState(false);

    const dispatch = useDispatch()

    const getAllNotes = () => {
        const body = editor.getBody();
        let sceneCount = 0
        const noteList = []

        body.childNodes.forEach((node) => {
            if (node.classList[0] === 'sceneHeadings') {
                sceneCount++;
            }
            if (node.getAttribute('data-note-list')) {
                const tempNoteList = JSON.parse(node.getAttribute('data-note-list') || "null") || []
                noteList.push(...tempNoteList.map(note => {
                    return {...note,scene:sceneCount}
                }));
            }
        })

        dispatch(setNotes(noteList));
        return noteList;
    };

    const handleContentChange = (e) => {
        if (!editor) {
            return
        }
        reloadScenes()
        reloadCharacters()
        reloadElements()
        reloadSceneCards()
        getAllNotes()
    }

    const reloadScenes = () => {
        const sceneObject = getScenes(editor)
        dispatch(setScenes(sceneObject))
    }

    const reloadCharacters = () => {
        const charObject = getCharacter(editor)
        dispatch(setCharacters(charObject))
    }

    const reloadElements = () => {
        setSceneElements(getElements(editor))
    }

    const reloadSceneCards = () => {
        setSceneCards(getSceneCards(editor))
    }

    useEffect(() => {
        if (editor) {
            handleContentChange()

            editor.on('change', handleContentChange)
            return () => {
                editor.off('change', handleContentChange)
            }
        }
    }, [editor])

    useEffect(() => {
        fetchRevisions()
    }, [])


    const fetchRevisions = async () => {

        const token = getAccessToken()
        const url = `${process.env.REACT_APP_DEV_API}/document/${id}/revision`
        try {
            const res = await fetch(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            if (!res.ok) {
                throw new Error('Error getting response', res)
            }
            const body = await res.json()

            setRevisions(body.data)

        } catch (error) {
            console.error(error)
        }
    }

    const getUsersPermission = () => {
        let permissionToEdit = false;
        if (scriptData?.userId === user?._id) {
            permissionToEdit = true;
        }
        else {
            const userInInviteList = scriptData?.invitedCollaborators?.find(u => u.userId._id === user?._id);
            if (userInInviteList) {
                permissionToEdit = userInInviteList?.permissions?.SCRIPT === "WRITE";
            }
        }
        return permissionToEdit;
    };

    useEffect(() => {
        if (!isPopUpOpen && scriptAccess?.canManage) {
            fetchCollaborator();
            const permissionToEdit = getUsersPermission();
            setHavePermissionToEdit(permissionToEdit);
        } else {
            setIsLoading(false);
            if (scriptData?.userId === user?._id) {
                setHavePermissionToEdit(true);
            } else {
                const permissionToEdit = getUsersPermission();
                setHavePermissionToEdit(permissionToEdit);
            }
        }

    }, [isPopUpOpen, updateCollaborators, scriptAccess?.canManage]);

    const fetchCollaborator = async () => {
        setIsLoading(true);
        const token = getAccessToken();
        try {
            const response = await fetch(
                `${process.env.REACT_APP_DEV_API}/documents/${id}/invites`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setIsLoading(false);
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const data = await response.json();
            setUsers(data.data);
        } catch (error) {
            setIsLoading(false)
            console.error("There was a problem with the fetch operation:", error);
            toast.error('Error loading collaborators')
        }
    };

    useEffect(() => {
        if (editor)
            reloadScenes()
    }, [updateScenes])

    useEffect(() => {
        if (editor)
            reloadCharacters()
    }, [updateCharacters])

    useEffect(() => {
        if (editor)
            reloadElements()
    }, [updateElements])

    useEffect(() => {
        if (editor)
            reloadSceneCards()
    }, [scenes])




    const openSubscriptionModal = () => {
        setIsSubscriptionModalOpen(true)
    }

    const isScriptAdmin = scriptAccess?.canManage === true
    const canOpenAI = scriptAccess?.permission === 'OWNER' || (havePermissionToEdit && scriptAccess?.canUseAI === true)


    const PanelOption = ({ title, isDisabled, subtitle, Icon, color, background, onClick, isTreatMentDisabled }) => {


        return (
            <div onClick={isDisabled ? openSubscriptionModal : isTreatMentDisabled ? () => { } : onClick} className='desktop-editor-panel-option w-full cursor-pointer border transition-all hover:shadow-lg p-3 py-2 h-fit rounded-lg flex justify-between items-center'>
                <div className='flex gap-4'>
                    <div className={`rounded-full flex items-center justify-center size-8`} style={{ background: isDisabled || isTreatMentDisabled ? '#F6F6F6' : background }}>
                        <Icon size={18} color={isDisabled || isTreatMentDisabled ? "#AAAAAA" : color} />
                    </div>
                    <div>
                        <p className='text-[13px] font-medium' style={{ color: isDisabled || isTreatMentDisabled ? '#868686' : '#292929' }}>{title}</p>
                        <p className='text-[11px] font-medium' style={{ color: isDisabled || isTreatMentDisabled ? '#AAAAAA' : '#757575' }}>{subtitle}</p>
                    </div>
                </div>
                <MdChevronRight size={24} color={'#CACACA'} />
            </div>
        )
    }

    const { invitedCollaborators } = scriptData;

    return (
        <div className={`${mobileProductionOpen || mobileMenuOpen ? 'max-lg:fixed max-lg:inset-0 max-lg:z-[85] max-lg:m-0 max-lg:w-full max-lg:h-full max-lg:rounded-none' : 'max-lg:hidden'} h-[calc(100%-12px)] bg-white p-4 mt-3 shadow-xl xl:w-[350px] w-[300px] border rounded-xl`}>
            {isLoading ?
                <div className='flex justify-center mt-40'>
                    <LoaderSpin size={24} />
                </div>

                :
                <>
                    {activePanel === '' &&
                        <div className='gap-2 flex flex-col h-full overflow-y-auto'>
                            {mobileMenuOpen && <Button className='lg:hidden shrink-0' onClick={onCloseMobileMenu}>Back to screenplay</Button>}

                            <PanelOption onClick={() => { setPanel('scene') }} title={'Scenes'} subtitle={`${!scenes?.allScenes ? 'No' : scenes?.allScenes?.length} Scenes`}
                                Icon={MdMovie} isTreatMentDisabled={scriptData.type === "TREATMENT"} color={'#CC8C14'} background={'#FDF8EE'} isDisabled={!planFeatures.canListScenes} />

                            <PanelOption onClick={() => { setPanel('character') }} title={'Characters'} subtitle={`${!characters ? 'No' : characters.length} Characters`}
                                Icon={MdOutlineSentimentSatisfied} isTreatMentDisabled={scriptData.type === "TREATMENT"} color={'#48A966'} background={'#F2FFF6'} isDisabled={!planFeatures.canUseCharacterBreakdown} />

                            <PanelOption onClick={() => { setPanel('sceneCards') }} title={'Scene Cards'} subtitle={'Organize Scenes'}
                                Icon={MdAmpStories} color={'#D41E79'} isTreatMentDisabled={scriptData.type === "TREATMENT"} background={'#FFF5FA'} isDisabled={!planFeatures.canUseSceneBreakdown} />


                            {canOpenAI && <PanelOption onClick={() => onOpenMedia('storyboard')} title={'Storyboard'} subtitle={'Saved storyboards and scene generation'} Icon={MdViewQuilt} color={'#0099FF'} background={'#EAF6FF'} />}
                            {!canOpenAI && scriptAccess?.permission && scriptAccess.permission !== 'OWNER' && <PanelOption onClick={() => setSharedStoryboardsOpen(true)} title={'Storyboard'} subtitle={'View shared storyboards'} Icon={MdViewQuilt} color={'#0099FF'} background={'#EAF6FF'} />}
                            {sharedStoryboardsOpen && <SharedStoryboardViewer scriptId={id} open={sharedStoryboardsOpen} onClose={() => setSharedStoryboardsOpen(false)} />}
                            {canOpenAI && <PanelOption onClick={() => onOpenMedia('video')} title={'AI Video'} subtitle={'AI Video and Premium Video'} Icon={MdVideocam} color={'#48A966'} background={'#F2FFF6'} />}

                            <PanelOption onClick={() => { setPanel('elements') }} title={'Pre-Production'} subtitle={'Manage production elements'}
                                Icon={MdTheaters} color={'#CC8C14'} isTreatMentDisabled={scriptData.type === "TREATMENT"} background={'#FDF8EE'} isDisabled={!planFeatures.canUseCategoriesAndElements} />


                            <PanelOption onClick={() => { setPanel('revision') }} title={'Revisions'} subtitle={`${!revisions || revisions?.length === 0 ? 'No' : revisions.length} Revisions`}
                                Icon={FaHighlighter} color={'#D41E79'} background={'#FFF5FA'} isDisabled={!planFeatures.canApplyRevision} isTreatMentDisabled={!isScriptAdmin} />


                            <PanelOption onClick={() => { setPanel('note') }} title={'Notes'} subtitle={notes.length === 0 ? 'No Notes' : notes.length + ' Notes'}
                                Icon={BsChatDotsFill} color={'#48A966'} background={'#F2FFF6'} isDisabled={!planFeatures.canApplyRevision} />


                        </div>
                    }
                    {activePanel === 'invite' && (
                        <InvitePanel
                            users={users}
                            setUsers={setUsers}
                            setPanel={setPanel}
                            isScriptAdmin={isScriptAdmin}
                            isPopUpOpen={isPopUpOpen}
                            setIsPopUpOpen={setIsPopUpOpen}
                            updateCollaborators={updateCollaborators}
                            setUpdateCollaborators={setUpdateCollaborators}
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                        />
                    )}
                    {activePanel === 'scene' && <ScenePanel setUpdateScenes={setUpdateScenes} setPanel={setPanel} editor={editor} permissionToEdit={havePermissionToEdit} />}
                    {activePanel === 'character' && <CharacterPanel setPanel={setPanel} editor={editor} setUpdateCharacters={setUpdateCharacters} permissionToEdit={havePermissionToEdit} />}
                    {activePanel === 'revision' && <RevisionsPanel setRevisions={setRevisions} setPanel={setPanel} scriptData={scriptData} />}
                    {activePanel === 'elements' && <ElementsPanel editor={editor} setPanel={mobileProductionOpen ? onCloseMobileProduction : setPanel} sceneElements={sceneElements} setUpdateElements={setUpdateElements} permissionToEdit={havePermissionToEdit} />}
                    {activePanel === 'sceneCards' && <SceneCardPanel editor={editor} setPanel={setPanel} sceneCards={sceneCards} permissionToEdit={havePermissionToEdit} />}
                    {activePanel === 'note' && <NotesPanel setPanel={setPanel} getUsersPermission={getUsersPermission} notes={notes} />}
                </>}

            <SubscriptionModal isSubscriptionModalOpen={isSubscriptionModalOpen} setIsSubscriptionModalOpen={setIsSubscriptionModalOpen} />
        </div>

    )
}

export default SidePanel